// Vue
import { Component } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "../../../../components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ProductPartnerAdvantagesManuelModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    return instance["advantage1"]["white"];
  }

  get partnerAdvantages() {
    return this.instance["advantage1"];
  }

  get modelAdvantages() {
    return this.instance["advantage2"];
  }
}
